import React, { useState, useRef } from "react";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Toast } from "primereact/toast";
import { Widget } from "@uploadcare/react-widget";
import axios from "axios";

import id from "../../images/id.png";
import SettingMenu from "../component/SettingMenu";
import { useTranslation } from "react-i18next";

const SettingsSecurity = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [imageId, setImageId] = useState(null);
  const toast = useRef(null);

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleUploadChange = (fileInfo) => {
    const uploadedImageId = fileInfo.uuid;
    setImageId(uploadedImageId);
  };

  const submitImageId = async () => {
    if (!imageId) {
      toast.current.show({
        severity: "error",
        summary: "Upload Error",
        detail: "Please upload an image first.",
      });
      return;
    }

    try {
      const response = await axios.get(
        "https://miracleapi.com/user/postImage",
        { params: { imageId } }
      );

      toast.current.show({
        severity: "success",
        summary: "Upload Success",
        detail: `Successfully posted image ID: ${imageId}`,
      });
      toggleModal();
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Upload Error",
        detail: "Failed to post image ID to the server.",
      });
    }
  };

  return (
    <div>
      <Header />
      <PageTitle />
      <div className="settings mb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingMenu />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">{t("security.label")}</h4>
                </div>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-xl-4">
                      <div className="id_card">
                        <img src={id} alt="" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="id_info">
                        <h3>{t("id.upload.label")}</h3>
                        <p className="mb-1 mt-3">
                          {t("id.upload.description")}
                        </p>
                        <p className="mb-1">
                          Status:{" "}
                          <span className="font-weight-bold">Verified</span>
                        </p>
                        <Button color="primary" onClick={toggleModal}>
                          New ID
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* Upload Modal */}
                  <Modal isOpen={modalOpen} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                      Upload New ID
                    </ModalHeader>
                    <ModalBody>
                      <Widget
                        publicKey={process.env.REACT_APP_UPLOADCARE_PUB_KEY}
                        multiple={false}
                        imagesOnly
                        onChange={handleUploadChange}
                        tabs="file url"
                        previewStep
                      />
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="primary"
                        onClick={submitImageId}
                        disabled={!imageId}
                      >
                        Submit
                      </Button>
                      <Button color="secondary" onClick={toggleModal}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Modal>

                  <Toast ref={toast} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSecurity;
